export default defineNuxtPlugin(() => {
  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason)
    
    // Don't show error messages to users for module loading failures
    if (event.reason?.message?.includes('Failed to fetch dynamically imported module') ||
        event.reason?.message?.includes('Loading chunk') ||
        event.reason?.message?.includes('Loading CSS chunk')) {
      event.preventDefault()
      return
    }
    
    // For other errors, you might want to send to error tracking
    // but don't expose technical details to users
  })

  // Handle general errors
  window.addEventListener('error', (event) => {
    console.error('Global error:', event.error)
    
    // Don't show technical error messages to users
    if (event.error?.message?.includes('Failed to fetch dynamically imported module') ||
        event.error?.message?.includes('Loading chunk') ||
        event.error?.message?.includes('Loading CSS chunk')) {
      event.preventDefault()
      return
    }
  })

  // Handle script loading errors
  window.addEventListener('error', (event) => {
    if (event.target && event.target.tagName === 'SCRIPT') {
      const script = event.target as HTMLScriptElement
      if (script.src && script.src.includes('_nuxt/')) {
        console.error('Script loading error:', script.src)
        event.preventDefault()
        return
      }
    }
  }, true)
})
